import script from "./FourthView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FourthView.vue?vue&type=script&setup=true&lang=ts"

import "./FourthView.vue?vue&type=style&index=0&id=75a373cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75a373cc"]])

export default __exports__